export const QUOTE_RECOVERY_KEY = 'QuoteEdit-recovery'

export function getQuoteRecoveryKey(id: string) {
  // save under <KEY>.id if it's a saved quote, or <KEY>.new if it's a new, unsaved quote
  return `${QUOTE_RECOVERY_KEY}.${id}`
}
